var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": "500" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    attrs: {
                      disabled: _vm.filteredSourceTypes.length === 0,
                      small: "",
                      color: "info",
                    },
                  },
                  on
                ),
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("add")]),
                  _vm._v("\n      Add data source..\n    "),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        { attrs: { dark: "" } },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c("v-toolbar-title", [_vm._v("Add Data Source")]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "", dark: "" },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-form",
            { ref: "form" },
            [
              _c(
                "v-alert",
                {
                  staticClass: "my-0",
                  attrs: {
                    outline: "",
                    type: "warning",
                    value: _vm.sourceType && _vm.sourceDataTypes.length === 0,
                    transition: "fade",
                  },
                },
                [
                  _c("div", { staticClass: "primary--text" }, [
                    _vm._v(
                      "\n          All data sources of this type are already assigned.\n        "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("p", [
                    _vm._v(
                      "\n          Data sources must be unassigned to add. To move them, use the Data Sources tab on this page.\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      label: "Data Type",
                      clearable: "",
                      rules: [_vm.rules.required],
                      items: _vm.filteredSourceTypes,
                      "item-value": "key",
                      "item-text": "dataType",
                      hint: "Only showing data types available for this location, since a location can only have one of each data types.",
                      "persistent-hint": "",
                    },
                    model: {
                      value: _vm.sourceType,
                      callback: function ($$v) {
                        _vm.sourceType = $$v
                      },
                      expression: "sourceType",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    attrs: {
                      label: "Data Source",
                      "no-data-text": "No data types available",
                      clearable: "",
                      rules: [_vm.rules.required],
                      "item-text": "LocationIdentifier",
                      "return-object": "",
                      items: _vm.sourceDataTypes,
                      disabled:
                        !_vm.sourceType || _vm.sourceDataTypes.length === 0,
                      hint: "Only showing data sources that do are not already assigned to a location",
                      "persistent-hint": "",
                    },
                    model: {
                      value: _vm.newDataType,
                      callback: function ($$v) {
                        _vm.newDataType = $$v
                      },
                      expression: "newDataType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "info" },
                  on: {
                    click: function ($event) {
                      return _vm.submit()
                    },
                  },
                },
                [
                  _c("v-icon", { staticClass: "mr-2" }, [_vm._v("add")]),
                  _vm._v("\n        Add\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { depressed: "" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v("\n        Cancel\n      ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }